<template>
	<el-dialog title="停车场详情" v-model="isDetail" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<p class="platTitle">基础信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>停车场名称</span>
						</div>
						<el-input v-model="whName" class="platItemRigth" placeholder="请输入" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>停车场类型</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="whType" placeholder="请选择停车场类型" disabled>
								<el-option label="停车场" value="pl" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>所属客商</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="whProvider" placeholder="请选择所属客商" disabled>
								<el-option v-for="item in ProviderList" :key="item.cocId" :label="item.cocName"
									:value="item.cocId" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备注</span>
						</div>
						<el-input v-model="whRemark" class="platItemRigth" placeholder="请输入" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>所在区域</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="whPcode" placeholder="请选择省" @change="getConProvince($event)" disabled>
								<el-option v-for="item in provinceList" :key="item.code" :label="item.name"
									:value="item.code" />
							</el-select>
							<el-select v-model="whCcode" placeholder="请选择市" @change="getConCity($event)" disabled>
								<el-option v-for="item in cityList" :key="item.code" :label="item.name"
									:value="item.code" />
							</el-select>
							<el-select placeholder="请选择区县" v-model="whAcode" disabled>
								<el-option v-for="item in areaList" :key="item.code" :label="item.name"
									:value="item.code" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>详细地址</span>
						</div>
						<el-input v-model="whAddr" class="platItemRigth" placeholder="请输入" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>联系人</span>
						</div>
						<el-input v-model="whContact" class="platItemRigth" placeholder="请输入" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>地址经纬度</span>
						</div>
						<el-input v-model="whLnglat" class="platItemRigth" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>联系电话</span>
						</div>
						<el-input v-model="whPhone" class="platItemRigth" placeholder="请输入" readonly />
					</div>
				</div>
			</div>

			<div class="footer_btn_warp">
				<div class="cancle_btn" v-on:click="closeModal()">关闭</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	export default defineComponent({
		name: "Detail",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				nextTick(() => {
					getProvinceList();
					getProviderList(); //获取客商
				});
			});
			const data = reactive({
				isDetail: false,
				provinceList: [], //省
				cityList: [], //市
				areaList: [], //区县
				ProviderList: [], //所属客商
				whId: "",
				whProvider: "1745668534717",
				whType: "1",
				whName: "客商机构站点",
				whPcode: "1",
				whCcode: "1",
				whAcode: "1",
				whAddr: "1",
				whLnglat: "1",
				whContact: "1",
				whPhone: "1",
				whContact2: "1",
				whPhone2: "1",
				whRemark: "1"
			});
			//重置数据
			const init = async (id) => {
				data.isDetail = true;
				data.whId = id;
				let params = {
					whId: id,
				};
				const r = await proxy.$http.get(apiObj.siteDetail, params);
				if (r) {
					data.whProvider = r.warehouse.whProvider;
					data.whType = r.warehouse.whType;
					data.whName = r.warehouse.whName;
					data.whPcode = r.warehouse.whPcode;
					data.whCcode = r.warehouse.whCcode;
					getCityList(data.whPcode);
					data.whAcode = r.warehouse.whAcode;
					getAreaList(data.whCcode);
					data.whAddr = r.warehouse.whAddr;
					data.whLnglat = r.warehouse.whLnglat;
					data.whContact = r.warehouse.whContact;
					data.whPhone = r.warehouse.whPhone;
					data.whContact2 = r.warehouse.whContact2;
					data.whPhone2 = r.warehouse.whPhone2;
					data.whRemark = r.warehouse.whRemark;
				}
			};

			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};
			const submit = async () => {
				if (data.driName == "") {
					proxy.$message.error("请填写司机名称");
					return;
				}
				if (data.driPhone == "") {
					proxy.$message.error("请填写手机号");
					return;
				}

				let params = {
					whId: data.whId,
					whProvider: data.whProvider,
					whType: data.whType,
					whName: data.whName,
					whPcode: data.whPcode,
					whCcode: data.whCcode,
					whAcode: data.whAcode,
					whAddr: data.whAddr,
					whLnglat: data.whLnglat,
					whContact: data.whContact,
					whPhone: data.whPhone,
					whContact2: data.whContact2,
					whPhone2: data.whPhone2,
					whRemark: data.whRemark

				}

				const r = await proxy.$http.post(apiObj.siteUpdate, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					data.isDetail = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};
			//数组去重
			const uniqueArr = (array = []) => {
				var n = []; //一个新的临时数组
				//遍历当前数组
				for (var i = 0; i < array.length; i++) {
					//如果当前数组的第i已经保存进了临时数组，那么跳过，
					//否则把当前项push到临时数组里面
					if (n.indexOf(array[i]) == -1) n.push(array[i]);
				}
				return n;
			};
			//获取所属客商
			const getProviderList = async () => {
				let params = {
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get(apiObj.cusList, params);
				console.log(res);
				if (res.code == 0) {
					data.ProviderList = res.rows;
				}
			};
			const getProvinceList = async () => {
				let params = {
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get("/admin/bdzl/province/list", params);
				console.log(res);
				if (res.code == 0) {
					data.provinceList = res.rows;
				}
			};

			const getConProvince = (ev) => {
				console.log(ev);
				data.cityList = [];
				data.orgCity = "";
				data.areaList = [];
				data.orgArea = "";
				getCityList(ev);
			};

			const getCityList = async (code) => {
				let params = {
					provinceCode: code,
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get("/admin/bdzl/city/list", params);
				console.log(res);
				if (res.code === 0) {
					data.cityList = res.rows;
				}
			};

			const getConCity = (ev) => {
				data.areaList = [];
				data.orgArea = "";
				getAreaList(ev);
			};

			const getAreaList = async (code) => {
				let params = {
					cityCode: code,
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get("/admin/bdzl/area/list", params);
				console.log(res);
				if (res.code == 0) {
					data.areaList = res.rows;
				}
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				dialogClosedHandle,
				submit,
				uniqueArr,
				getConProvince,
				getConCity,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 80px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}
</style>